import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../DatiSpecifici/DatiSpecifici.module.css";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import Utils from "../../../../../utils/Utils";


class Parte2 extends Component {

    state = {
        parte2: {
            terapiaModificata: "",
            esitoTrattamento: "",
            trattamentoInterrotto: "",
            trasferitoA: "",
            dataChiusuraParte2: ""
        },
        boxes: []
    }


    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloDati = this.controlloDati.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.renderDiv = this.renderDiv.bind(this)
        this.validate = this.validate.bind(this);

    }

    componentDidMount() {
        let parte2 = this.state.parte2
        let parte2Copia = this.props.segnalazioneCopia.esitoTbcPolmonare && this.props.segnalazioneCopia.esitoTbcPolmonare.parte2 ?
            this.props.segnalazioneCopia.esitoTbcPolmonare.parte2 : ""
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.esitoTbcPolmonare && parte2Copia) {
            for (let key in parte2) {
                if (parte2.hasOwnProperty(key) === parte2Copia.hasOwnProperty(key)) {
                    if (key === "dataChiusuraParte2") {
                        parte2[key] = Utils.transformDateForFrontend(parte2Copia[key])
                    } else {
                        parte2[key] = parte2Copia[key]
                    }
                } else {
                    parte2[key] = ""
                }
            }
            this.setState({parte2: parte2})
        }
        this.renderDiv()
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte2", oggettoBE, corretto)
    }

    validate() {
        if (this.state.parte2.dataChiusuraParte2 && Utils.validateDate(this.state.parte2.dataChiusuraParte2, "Messages.DataChiusura", "Messages.DataChiusuraOdierna")) {
            return Utils.validateDate(this.state.parte2.dataChiusuraParte2, "Messages.DataChiusura", "Messages.DataChiusuraOdierna")
        }
        return ""
    }

    riceviValore(field, event) {
        let parte2 = this.state.parte2
        parte2[field] = event.target.value
        if (parte2.esitoTrattamento !== "5") {
            parte2.trattamentoInterrotto = ""
        }
        if (parte2.esitoTrattamento !== "7") { // vecchio esito = 6 trasferito a , nuovo esito = 6 perso follow up
            parte2.trasferitoA = ""
        }

        this.setState({parte2: parte2})
        this.renderDiv()
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte2", oggettoBE, corretto, this.validate())
    }

    controlloDati() {
        let parte2 = this.state.parte2
        let corretto = []

        if(!parte2.dataChiusuraParte2 || (parte2.dataChiusuraParte2 && Utils.isDateInValid(Utils.transformDateForBackend(parte2.dataChiusuraParte2), "-"))) corretto[0] = "Campo \"Data di chiusura parte 2\" mancante o errato";
        if(!parte2.terapiaModificata) corretto[1] = "Campo \"Terapia modifica\" mancante";
        if(!parte2.esitoTrattamento || (parte2.esitoTrattamento === "7" && !parte2.trasferitoA) || (parte2.esitoTrattamento === "5" && !parte2.trattamentoInterrotto)) corretto[2] = "Campo \"Esito del trattamento:*(selezionare solo una voce)\" mancante";

        return corretto
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.parte2))
        oggettoBE.dataChiusuraParte2 = Utils.transformDateForBackend(oggettoBE.dataChiusuraParte2)
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    renderDiv() {

        const {t} = this.props

        let rows = [
            {
                esitoLabel: {
                    text: "SchedaSpecialeTbcPolmonare.esitoTrattamento",
                    textAggiuntivo: "SchedaSpecialeTbcPolmonare.selSoloUnaVoce",
                    tipo: "label",
                    colonna: 1,
                    asterisco: true
                }
            },
            {
                guarito: {
                    id: "esitoTrattamentoGuarito",
                    text: "SchedaSpecialeTbcPolmonare.guarito",
                    tipo: "radio",
                    name: "esitoTrattamento",
                    value: "1",
                    colonna: 1
                },
                followup: {
                    id: "esitoTrattamentoFollowup",
                    text: "SchedaSpecialeTbcPolmonare.followup",
                    tipo: "radio",
                    name: "esitoTrattamento",
                    value: "6",
                    colonna: 2
                },
            },
            {
                completato: {
                    id: "esitoTrattamentoCompletato",
                    text: "SchedaSpecialeTbcPolmonare.trattamentoCompletato",
                    tipo: "radio",
                    name: "esitoTrattamento",
                    value: "3",
                    colonna: 1
                },
                fallimento: {
                    id: "esitoTrattamentoFallimento",
                    text: "SchedaSpecialeTbcPolmonare.fallimento",
                    tipo: "radio",
                    name: "esitoTrattamento",
                    value: "2",
                    colonna: 2
                },
            },
            {
                interrotto: {
                    id: "esitoTrattamentoInterrotto",
                    text: "SchedaSpecialeTbcPolmonare.trattamentoInterotto",
                    tipo: "radio",
                    name: "esitoTrattamento",
                    value: "5",
                    colonna: 1,
                    required: this.state.parte2.esitoTrattamento === "5"
                },
                effettiCollaterali: {
                    id: "trattamentoInterrottoEffettiCollaterali",
                    text: "SchedaSpecialeTbcPolmonare.effettiCollaterali",
                    tipo: "radio",
                    name: "trattamentoInterrotto",
                    value: "1",
                    disabled: this.state.parte2.esitoTrattamento !== "5",
                    colonna: 2
                },
                nonCollaborante: {
                    id: "trattamentoInterrottoNonCollaborante",
                    text: "SchedaSpecialeTbcPolmonare.pazienteNonCollaborante",
                    tipo: "radio",
                    name: "trattamentoInterrotto",
                    value: "2",
                    disabled: this.state.parte2.esitoTrattamento !== "5",
                    colonna: 3
                },
            },
            {
                trasferito: {
                    id: "esitoTrattamentoTrasferito",
                    text: "SchedaSpecialeTbcPolmonare.trasferitoA",
                    tipo: "radio",
                    name: "esitoTrattamento",
                    value: "7",
                    colonna: 1
                },
                indirizzo: {
                    id: "trasferitoA",
                    field: "trasferitoA",
                    text: "SchedaSpecialeTbcPolmonare.trasferitoA",
                    tipo: "input",
                    required: this.state.parte2.esitoTrattamento === "7",
                    disabled: this.state.parte2.esitoTrattamento !== "7",
                    colonna: 2
                },
            },
            {
                deceduto: {
                    id: "esitoTrattamentoDeceduto",
                    text: "SchedaSpecialeTbcPolmonare.deceduto",
                    tipo: "radio",
                    name: "esitoTrattamento",
                    value: "4",
                    colonna: 1
                },
            },
            {
                label: {
                    text: "SchedaSpecialeTbcPolmonare.dataChiusuraParte2",
                    tipo: "label",
                    colonna: 1,
                    asterisco: true
                },
                dataChiusurParte2: {
                    id: "dataChiusuraParte2",
                    field: "dataChiusuraParte2",
                    text: "SchedaSpecialeTbcPolmonare.dataChiusuraParte2",
                    tipo: "data",
                    colonna: 2
                },
            }
        ]

        let boxes = Utils.createDiv("col-lg-4", "col-lg-4", "col-lg-4", this.riceviValore, this.state.parte2, t, rows)
        return this.setState({boxes: boxes})
    }

    render() {

        const {t} = this.props
        const parte2 = (
            <div style={{marginTop: "3rem"}}>
                <h6>{t("SchedaSpecialeTbcPolmonare.parte2")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-lg-3"}>
                            <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeTbcPolmonare.terapiaModificata")}
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className={"col-lg-4"}>
                            <div className={"row"}>
                                <RadioButton id={"terapiaModificataNo"}
                                             name={"terapiaModificata"} label={t("SchedaSpecialeTbcPolmonare.no")}
                                             value={"2"}
                                             newRadio={true}
                                             style={{color: "black"}}
                                             onClick={this.riceviValore}
                                             checked={this.state.parte2.terapiaModificata === "2"}/>
                                <RadioButton id={"terapiaModificataSi"}
                                             name={"terapiaModificata"} label={t("SchedaSpecialeTbcPolmonare.si")}
                                             value={"1"}
                                             newRadio={true}
                                             style={{color: "black"}}
                                             onClick={this.riceviValore}
                                             checked={this.state.parte2.terapiaModificata === "1"}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"container"}>
                    {this.state.boxes}
                </div>
            </div>
        )
        return (
            <div>
                {parte2}
            </div>
        );
    }


}

export default withTranslation('common')(Parte2)
